var map = {
	"./PAP_cat_icon_1-to-1.svg": [
		1536,
		45
	],
	"./PAP_cat_icon_1to1-other.svg": [
		1686,
		46
	],
	"./PAP_cat_icon_blog-theme-design.svg": [
		1687,
		47
	],
	"./PAP_cat_icon_book-cover-design.svg": [
		1688,
		48
	],
	"./PAP_cat_icon_brochure-or-menu-design.svg": [
		1689,
		49
	],
	"./PAP_cat_icon_business-card-design.svg": [
		1690,
		50
	],
	"./PAP_cat_icon_business-tagline.svg": [
		1691,
		51
	],
	"./PAP_cat_icon_design-consultation.svg": [
		1537,
		52
	],
	"./PAP_cat_icon_email-design.svg": [
		1692,
		53
	],
	"./PAP_cat_icon_icon-button-and-widget-design.svg": [
		1693,
		54
	],
	"./PAP_cat_icon_illustration-and-graphic-design.svg": [
		1694,
		55
	],
	"./PAP_cat_icon_infographics-design.svg": [
		1695,
		56
	],
	"./PAP_cat_icon_landing-page-design.svg": [
		1696,
		57
	],
	"./PAP_cat_icon_letterhead-and-stationery-design.svg": [
		1697,
		58
	],
	"./PAP_cat_icon_logo-and-business-card-design.svg": [
		1698,
		59
	],
	"./PAP_cat_icon_logo-and-social-media-assets-design.svg": [
		1699,
		60
	],
	"./PAP_cat_icon_logo-design.svg": [
		1700,
		61
	],
	"./PAP_cat_icon_magazine-cover-design.svg": [
		1701,
		62
	],
	"./PAP_cat_icon_merchandise-design.svg": [
		1702,
		63
	],
	"./PAP_cat_icon_mobile-ui-design.svg": [
		1703,
		64
	],
	"./PAP_cat_icon_naming-a-business-or-product.svg": [
		1704,
		65
	],
	"./PAP_cat_icon_other-clothing-design.svg": [
		1705,
		66
	],
	"./PAP_cat_icon_outdoor-or-signage-design.svg": [
		1706,
		67
	],
	"./PAP_cat_icon_package-graphics.svg": [
		1707,
		68
	],
	"./PAP_cat_icon_packaging-design.svg": [
		1708,
		69
	],
	"./PAP_cat_icon_postcard-or-flyer-design.svg": [
		1709,
		70
	],
	"./PAP_cat_icon_poster-design.svg": [
		1710,
		71
	],
	"./PAP_cat_icon_presentation-design.svg": [
		1711,
		72
	],
	"./PAP_cat_icon_product-design.svg": [
		1712,
		73
	],
	"./PAP_cat_icon_social-media-assets-design.svg": [
		1713,
		74
	],
	"./PAP_cat_icon_t-shirt-design.svg": [
		1714,
		75
	],
	"./PAP_cat_icon_tattoo-design.svg": [
		1715,
		76
	],
	"./PAP_cat_icon_vehicle-wrap-design.svg": [
		1716,
		77
	],
	"./PAP_cat_icon_wall-mural-art-design.svg": [
		1717,
		78
	],
	"./PAP_cat_icon_web-banner-design.svg": [
		1718,
		79
	],
	"./PAP_cat_icon_website-design.svg": [
		1719,
		80
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1553;
module.exports = webpackAsyncContext;